import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import TakeAction from "@/pages/TakeAction";
import Resources from "@/pages/Resources";
import FactSheet from "@/pages/FactSheet";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import VoteAlertBanner from "@/components/VoteAlertBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VoteAlertBanner />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/take-action" element={<TakeAction />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/fact-sheet" element={<FactSheet />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
      <div className="noise-overlay" />
    </div>
  );
}

export default App;
